import React from 'react';
import { PhoneCall } from 'lucide-react';
import OBackButton from '../../../OBackButton';

const Hero = () => {
  const dummy = "https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/+pms/sparkk.png";
  const handleBackClick = () => {
    window.location.href = '/pms';
    setTimeout(() => {
      const element = document.getElementById('pms-offerings');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="relative bg-gradient-to-br from-[#113262] to-[#113262] isolate min-h-[75vh] flex items-center">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 lg:py-24">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left content */}
          <div className="w-full md:w-1/2 lg:w-3/5 text-white space-y-5 md:space-y-6 md:pr-8 pt-8 md:pt-4">
            <div className="flex items-center gap-2 mb-6 md:mb-4">
              <OBackButton to="/pms" onClick={handleBackClick} />
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4 leading-tight bg-gradient-to-r from-white to-[#A2B8D8] bg-clip-text text-transparent animate-slideUp py-2">
              Maxiom PMS - SPARK
            </h1>

            <p className="text-lg md:text-xl text-[#A2B8D8] animate-fadeIn opacity-0" style={{ animationDelay: '0.3s' }}>
              Faster growth from small-cap and quality companies
            </p>

            <p className="text-[#E8EEF6] text-sm md:text-base leading-relaxed animate-fadeIn opacity-0" style={{ animationDelay: '0.6s' }}>
              Achieve long-term capital appreciation by investing in a mix of small-cap companies that meet the Roots & Wings investment criteria. The portfolio has performed well beating benchmarks since launch in June 2021 (as equity advisory). Average market cap this portfolio is around 5000 crores making it not-so-small.
            </p>

            {/* Button container in a row */}
            <div className="flex flex-row gap-4 animate-fadeIn opacity-0 mt-6 md:mt-8" style={{ animationDelay: '0.9s' }}>
              <a
                href="https://club.maxiomwealth.com/login"
                className="bg-[#F49611] text-white px-8 py-4 rounded-lg hover:transform hover:-translate-y-1 hover:shadow-lg transition-all duration-300 font-semibold"
              >
                Get Started
              </a>
              <a href="/meeting"
                  className="border-2 border-[#A2B8D8] text-white px-5 py-2.5 md:px-6 md:py-3 rounded-lg hover:bg-white/10 transition-colors duration-300 flex items-center gap-2 font-semibold text-sm"
                >
                  <PhoneCall size={18} className="shrink-0" />
                  Schedule Meeting
                </a>
            </div>
          </div>

          {/* Right image - reduced vertical spacing on mobile */}
          <div className="w-full md:w-1/2 lg:w-2/5 pt-8 md:pt-20 mt-6 md:mt-12 md:mt-0 flex justify-center md:justify-end animate-fadeIn opacity-0" style={{ animationDelay: '1.2s' }}>
            <div className="relative w-full max-w-md px-4 md:px-0">
              <div className="absolute inset-0 rounded-full"></div>
              <img
                src={dummy}
                alt="Spark PMS visualization"
                className="relative z-10 w-full h-auto rounded-lg object-contain max-w-full scale-140"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;